import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkUserSubscriptionApi } from '../http/http';
import toast, { Toaster } from 'react-hot-toast';
import classes from './LoginPage.module.css';

const LoginPage = () => {
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
      
        if (phone.length < 9) {
            setError('Please enter a valid mobile number');
            return;
        }

        setLoading(true);
        try {
            const response = await checkUserSubscriptionApi(phone);
            
            // Normalize the status check to handle different possible API response structures
            const userStatus = (
                response.data?.data?.status || 
                response.data?.status || 
                response.data?.data?.subscriptionStatus || 
                ""
            ).toUpperCase();

            if (userStatus === 'REGISTERED') {
                // Scenario 1: Fully active user -> Let them in
                const userData = {
                    msisdn: phone,
                    masked_msisdn: response.data?.data?.masked_msisdn || '',
                    status: 'REGISTERED'
                };
                localStorage.setItem('userData', JSON.stringify(userData));
                if (response.data?.token) {
                    localStorage.setItem('token', response.data.token);
                }
                toast.success("Welcome back!");
                navigate('/'); 
                
            } else if (userStatus === 'REG_PENDING' || userStatus === 'PENDING') {
                
                toast.error(
                    "Your subscription is verified but pending payment confirmation. Please ensure you have sufficient balance. You will receive an SMS once active.",
                    { 
                        duration: 6000,
                        icon: '⏳',
                    }
                );
                setLoading(false);
                
            } else {
                // Scenario 3: Unregistered, Blocked, or something else -> Go to Subscribe
                handleNotSubscribed();
            }
        } catch (err) {
            if (err.response?.status === 404 || err.response?.status === 403) {
                // Not found in DB -> Go to Subscribe
                handleNotSubscribed();
            } else {
                const msg = err.response?.data?.message || 'Server error. Please try again.';
                setError(msg);
                toast.error(msg);
                setLoading(false);
            }
        }
    };

    const handleNotSubscribed = () => {
        toast.error("User not subscribed. Please subscribe first!"); 
        setLoading(false);
        setTimeout(() => {
            navigate('/subscribe', { state: { phone } });
        }, 2500);
    };

    return (
        <div className={classes.page_wrapper}>
            <Toaster position="top-center" reverseOrder={false} />
            <div className={classes.bg_blob_1}></div>
            <div className={classes.bg_blob_2}></div>

            <div className={classes.card}>
                <div className={classes.logo_area}>
                    <div className={classes.logo_icon_wrap}>
                        <img src="/assets/images/logo.png" alt="logo" className={classes.logo_icon} />
                    </div>
                    <p className={classes.logo_text}>Game<span>Plex</span></p>
                </div>

                <div className={classes.heading_area}>
                    <h1 className={classes.title}>Welcome back</h1>
                    <p className={classes.subtitle}>Sign in with your mobile number to continue</p>
                </div>

                <form className={classes.form} onSubmit={handleLogin}>
                    <div>
                        <span className={classes.field_label}>Mobile Number</span>
                        <div className={classes.input_group}>
                            <span className={classes.input_prefix}>+94</span>
                            <input
                                className={classes.input}
                                type="tel"
                                placeholder="7X XXX XXXX"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/g, ''))}
                                maxLength={12}
                                disabled={loading}
                            />
                        </div>
                    </div>

                    {error && <p className={classes.error_msg} style={{color: '#ff4d4d', fontSize: '13px', marginTop: '8px'}}>{error}</p>}

                    <button type="submit" className={classes.submit_btn} disabled={loading}>
                        {loading ? 'Checking Status...' : 'Login'}
                    </button>
                </form>

                <p className={classes.register_row}>
                    Don't have an account?{' '}
                    <button type="button" className={classes.register_link} onClick={() => navigate('/subscribe')}>
                        Subscribe Now
                    </button>
                </p>

                <p className={classes.terms_text}>
                    By continuing, you agree to our <span onClick={() => navigate('/privacy-policy')} className={classes.terms_link} style={{cursor: 'pointer'}}>Terms and Conditions</span>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;